import { reactive } from 'vue'
import { fetchMe, login as loginRequest, logout as logoutRequest, logoutAllSessions, exitImpersonation as exitImpersonationRequest } from './auth'

// Estado de sesión compartido por toda la app (router guard, SideBar, páginas).
const state = reactive({
  user: null,
  loading: true,
  initialized: false,
})

// Se asegura de pedir /auth/me una sola vez (la primera vez que algo la necesita,
// normalmente el router guard al cargar la app), y reutiliza el resultado después.
let pendingInit = null
function initSession() {
  if (state.initialized) return Promise.resolve(state.user)
  if (pendingInit) return pendingInit

  pendingInit = fetchMe()
    .then((user) => {
      state.user = user
      return user
    })
    .finally(() => {
      state.loading = false
      state.initialized = true
      pendingInit = null
    })
  return pendingInit
}

// El login devuelve solo datos básicos; pedimos /auth/me para tener el usuario completo
// (rol personalizado con permisos, parque, fechas...) que necesitan el router y la UI.
async function refreshUser() {
  const user = await fetchMe()
  state.user = user
  state.initialized = true
  state.loading = false
  return user
}

async function login(email, password) {
  await loginRequest(email, password)
  return refreshUser()
}

async function logout() {
  await logoutRequest()
  state.user = null
}

async function logoutAll() {
  await logoutAllSessions()
  state.user = null
}

async function exitImpersonation() {
  await exitImpersonationRequest()
  state.user = null
}

export function useAuthStore() {
  return { state, initSession, login, logout, logoutAll, refreshUser, exitImpersonation }
}